<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="800" scrollable persistent>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="rounded-lg">
          <v-card-title>
            แก้ไขข้อมูลผู้ใช้งาน<v-spacer></v-spacer>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text
            class="pt-6"
            v-for="(item, index) in _DataAccount.ArrayCheck"
            :key="index"
          >
            <v-layout row wrap justify-center align-center>
              <v-flex xs8 sm8 md8 lg3 pa-2>
                <span>คำนำหน้าภาษาไทย</span>
                <v-select
                  v-if="item.TitleTh == ''"
                  :items="ItemsTitleTh"
                  v-model="item.TitleTh"
                  dense
                  outlined
                  required
                  item-text="Text"
                  item-value="Value"
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-select>
                <v-select
                  v-else
                  :items="ItemsTitleTh"
                  v-model="_DataAccount.TitleTh"
                  dense
                  outlined
                  required
                  disabled
                  item-text="Text"
                  item-value="Value"
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-select>
              </v-flex>

              <v-flex xs8 sm8 md8 lg4 pa-2>
                <span>ชื่อภาษาไทย</span>
                <v-text-field
                  v-if="item.FirstNameTh == ''"
                  v-model="item.FirstNameTh"
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-text-field>
                <v-text-field
                  v-else
                  v-model="_DataAccount.FirstNameTh"
                  disabled
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 sm8 md8 lg4 pa-2>
                <span>นามสกุลภาษาไทย</span>
                <v-text-field
                  v-if="item.LastNameTh == ''"
                  v-model="item.LastNameTh"
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-text-field>
                <v-text-field
                  v-else
                  v-model="_DataAccount.LastNameTh"
                  required
                  disabled
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center align-center>
              <v-flex xs8 sm8 md8 lg3 pa-2>
                <span>คำนำหน้าภาษาอังกฤษ</span>
                <v-select
                  v-if="item.TitleEng == ''"
                  :items="ItemsTitleEng"
                  v-model="item.TitleEng"
                  dense
                  outlined
                  required
                  item-text="Text"
                  item-value="Value"
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-select>
                <v-select
                  v-else
                  :items="ItemsTitleEng"
                  v-model="_DataAccount.TitleEng"
                  dense
                  outlined
                  required
                  disabled
                  item-text="Text"
                  item-value="Value"
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-select>
              </v-flex>

              <v-flex xs8 sm8 md8 lg4 pa-2>
                <span>ชื่อภาษาอังกฤษ</span>
                <v-text-field
                  v-if="item.FirstNameEng == ''"
                  v-model="item.FirstNameEng"
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-text-field>
                <v-text-field
                  v-else
                  v-model="_DataAccount.FirstNameEng"
                  disabled
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 sm8 md8 lg4 pa-2>
                <span>นามสกุลภาษาอังกฤษ</span>
                <v-text-field
                  v-if="item.LastNameEng"
                  v-model="item.LastNameEng"
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-text-field>
                <v-text-field
                  v-else
                  v-model="_DataAccount.LastNameEng"
                  disabled
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-details-outline"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pb-5 pa-3">
            <v-spacer></v-spacer>
            <v-btn color="#077893" dark @click="Fn_Save()">
              {{ $t("policyForm.save") }}
            </v-btn>
            <v-btn color="#077893" outlined @click="Fn_Close()">
              {{ $t("consentform.close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import authorization from '@/functions/authorization.js'
import Swal2 from 'sweetalert2/dist/sweetalert2.js'
import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})

export default {
  props: ['show', 'data', 'email'],
  data: function () {
    return {
      valid: true,
      SelectTitleTh: '',
      SelectTitleEng: '',
      FirstNameTh: '',
      FirstNameEng: '',
      LastNameTh: '',
      LastNameEng: '',
      ItemsTitleTh: [
        { Text: 'นาย', Value: 'นาย' },
        { Text: 'นางสาว', Value: 'นางสาว' },
        { Text: 'นาง', Value: 'นาง' },
        { Text: 'เด็กชาย', Value: 'เด็กชาย' },
        { Text: 'เด็กหญิง', Value: 'เด็กหญิง' }
      ],
      ItemsTitleEng: [
        { Text: 'Mr', Value: 'Mr' },
        { Text: 'Miss', Value: 'Miss' },
        { Text: 'Mrs', Value: 'Mrs' },
        { Text: 'Master', Value: 'Master' }
      ],
      telReqiure: (v) => !!v || this.$i18n.t('Profile.checkphone')
    }
  },
  computed: {
    ...mapGetters(['DataAccount']),
    shower: {
      get () {
        return this.show
      },
      set (value) {
        if (!value) {
          this.$emit('closeDialogTel')
        }
      }
    },
    _DataAccount: {
      get () {
        return this.DataAccount || '-'
      }
    }
  },
  methods: {
    async Fn_Save () {
      if (this.$refs.form.validate()) {
        const payload = {
          AccessToken: this.$cookies.get('OneAccessToken'),
          AccountId: this.$cookies.get('OneAccountId'),
          Profile: this._DataAccount.ArrayCheck
        }
        var Headers = {
          AccountId: this.$cookies.get('OneAccountId')
        }
        var dataEncode = await authorization.encodeDataNew(payload)
        var auth = await authorization.encodeDataNew(Headers)
        var headers = { Authorization: 'Bearer ' + auth }
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              'token/UpdateAccountOneId',
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loading = false

            if (response.data.Status === 'OK') {
              this.$emit('closeDialogTel')
              this.$emit('reData')
              Toast.fire({
                icon: 'success',
                title: response.data.Message
              })
            } else {
              Toast.fire({
                icon: 'error',
                title: response.data.ErrorMessage
              })
            }
          })
          .catch((error) => {
            if (error.response) {
              Toast.fire({
                icon: 'error',
                title: error.response.data.ErrorMessage
              })
            } else if (error.request) {
              Toast.fire({
                icon: 'error',
                title: error.request
              })
            } else {
              Toast.fire({
                icon: 'error',
                title: error.message || error
              })
            }
          })
      }
    },
    Fn_Close () {
      this.$emit('closeDialog')
    }
  },
  watch: {
    show (val) {
      if (val === true) {
      }
    }
  }
}
</script>
